import React from 'react';
import 'twin.macro';
/* eslint-disable react/no-array-index-key */
import { Label } from './Label';
import { Color } from '@teetsh/app/src/types/colors';
import { ListsPrintView } from '@teetsh/app/src/types/sequences';

interface Props {
  items: string[];
  label?: string;
  labelPlural?: string;
  isLabelHighlighted?: boolean;
  view?: ListsPrintView;
  color?: Color;
}

interface ListProps {
  items: string[];
  view?: ListsPrintView;
}

function List(props: ListProps) {
  const { items, view } = props;
  if (!view) {
    return (
      <>
        {items.map((d, index) => (
          <div key={index}>{d}</div>
        ))}
      </>
    );
  }
  switch (view) {
    case 'inline':
      return <div>{items.join(', ')}</div>;
    case 'inline-list':
      return (
        <div>
          {items.map((d, index) => (
            <span key={index}>
              {d}
              {index !== items.length - 1 && <span tw="mx-3">•</span>}
            </span>
          ))}
        </div>
      );
    case 'list':
      return (
        <ul tw="list-disc pl-4 pb-2">
          {items.map((d, index) => (
            <li key={index} tw="pb-0.5">
              {d}
            </li>
          ))}
        </ul>
      );
  }
}

export function ROItemList(props: Props) {
  const {
    items,
    label,
    labelPlural,
    isLabelHighlighted,
    view = isLabelHighlighted ? 'inline' : undefined,
    color,
  } = props;
  if (!items || items.length === 0) {
    return null;
  }

  const arrItems = typeof items === 'string' ? [items] : items;
  if (arrItems.length > 1) {
    return (
      <>
        {labelPlural && (
          <Label isHighlighted={isLabelHighlighted} color={color}>
            {labelPlural}
          </Label>
        )}
        <List view={view} items={arrItems} />
      </>
    );
  }
  return (
    <>
      {label && (
        <Label isHighlighted={isLabelHighlighted} color={color}>
          {label}
        </Label>
      )}
      <div>{arrItems[0]}</div>
    </>
  );
}
